import React, { useState } from 'react';
import { Typography, Grid, TextField, Paper, Button, Avatar, makeStyles } from '@material-ui/core';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import LinearProgress from '@material-ui/core/LinearProgress';
import { Link } from 'react-router-dom';
import { useAlerts } from '../hooks/alerts-hooks';
import { useAuth } from '../AuthCtx';

const useStyles = makeStyles((theme) => {
  return {
    paperWrapper: { padding: theme.spacing(0), overflow: 'hidden', maxWidth: 400 },
    formWrapper: { padding: theme.spacing(4, 4) },
    avatarStyle: { backgroundColor: theme.palette.primary.main },
    itemMargin: { margin: theme.spacing(1, 0) },
  };
});

const Login = () => {
  const classes = useStyles();

  const { alertError } = useAlerts();
  const { authenticate } = useAuth();

  const [ username, setUsername ] = useState('');
  const [ password, setPassword ] = useState('');
  const [ showPassword, setShowPassword ] = useState('');
  const [ loading, setLoading ] = useState(false);

  const onChangeUsername = (e) => {
    setUsername(e.target.value);
  };

  const onChangePassword = (e) => {
    setPassword(e.target.value);
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleOnClick = (e) => {
    e.preventDefault();
    return Promise.resolve()
      .then(() => {
        setLoading(true);
      })
      .then(() => {
        return authenticate({ username, password });
      })
      .catch((err) => {
        alertError(JSON.stringify(err));
      })
      .finally(() => { setLoading(false); });
  };

  return (
    <>
      <Grid item align='center'>
        <Paper elevation={ 1 } className={ classes.paperWrapper }>
          {loading && <LinearProgress />}
          <Paper elevation={ 0 } className={ classes.formWrapper }>
            <form onSubmit={ handleOnClick }>
              <FormControl>
                <Grid align='center'>
                  <Avatar className={ classes.avatarStyle }><LockOutlinedIcon /></Avatar>
                  <h2>Sign In</h2>
                </Grid>
                <TextField
                  required
                  className={ classes.itemMargin }
                  variant='outlined'
                  label='Username'
                  placeholder='Enter Username'
                  name='username'
                  fullWidth
                  onChange={ onChangeUsername }
                />
                <FormControl required variant='outlined'>
                  <InputLabel>Password</InputLabel>
                  <OutlinedInput
                    placeholder='Enter Password'
                    id='outlined-adornment-password'
                    type={ showPassword ? 'text' : 'password' }
                    value={ password }
                    onChange={ onChangePassword }
                    endAdornment={ (
                      <InputAdornment position='end'>
                        <IconButton
                          aria-label='toggle password visibility'
                          onClick={ handleClickShowPassword }
                          onMouseDown={ handleMouseDownPassword }
                          edge='end'
                        >
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ) }
                    labelWidth={ 70 }
                  />
                </FormControl>
                <FormControlLabel
                  control={ (
                    <Checkbox
                      name='checkedB'
                      color='primary'
                    />
                  ) }
                  label='Remember me'
                />
                <Button
                  disabled={ loading }
                  className={ classes.itemMargin }
                  type='submit'
                  color='primary'
                  variant='contained'
                  fullWidth
                >
                  Sign
                  In
                </Button>
                <Typography>
                  <Link to='/forgot-password'>Forgot password ?</Link>
                </Typography>
                <Typography>
                  {' '}
                  Do you have an account ?
                  <Link to='/register'> Register Now</Link>
                </Typography>
              </FormControl>
            </form>
          </Paper>
        </Paper>
      </Grid>
    </>
  );
};

export default Login;
